export enum NavigateOptions {
  /** Open link on same page */
  OnPage = 0,
  /** Open link in a new tab */
  NewTab = 1,
  /** Two tab view */
  TwoTabView = 2,
}
